<app-view-workflow-stats-panel *ngIf="workflowStatsDto" [contextIdDto]="contextIdDto" [workflowStatsDto]="workflowStatsDto"></app-view-workflow-stats-panel>
